// Heya Brand Colors (heya.flyin.com)
//
// Heya is a Flyin sub-brand: it inherits every neutral/semantic token from Flyin and
// only overrides the brand-owned ones below. Local exports shadow the star export.
export * from './flyin'

// Heya brand ramp, as handed over by design.
export const BRAND_50 = '#FFF0FA'
export const BRAND_100 = '#FFE1F5'
export const BRAND_200 = '#FFC1EC'
export const BRAND_300 = '#F998DE'
export const BRAND_400 = '#DF70C2'
export const BRAND_500 = '#C14AA5'
export const BRAND_600 = '#9D2E85'
export const BRAND_700 = '#7E1E69'
export const BRAND_800 = '#5E124E'
export const BRAND_900 = '#400834'
export const BRAND_950 = '#2A0322'

// 600 is the lightest step that clears WCAG AA for white text on a filled button
// (6.6:1); 500 only reaches 4.4:1, so it is not used as a primary surface.
export const BRAND_PRIMARY = BRAND_600
export const BRAND_PRIMARY_DARK = BRAND_700
export const BRAND_PRIMARY_LIGHT = BRAND_300
export const BRAND_PRIMARY_100 = BRAND_50
export const BRAND_PRIMARY_ALPHA_1 = '#F2E6EE'


// Design supplied one ramp, so the secondary/tonal button is the light end of the same
// ramp rather than a second hue — Flyin's gold would clash with magenta. It keeps
// Flyin's black secondary text, which stays legible on 200.
export const BRAND_SECONDARY = '#FFD700'
export const BRAND_SECONDARY_DARK = '#E6C200'
export const BRAND_SECONDARY_LIGHT = '#FFE066'

//link
export const LINK_MAIN = BRAND_600

//sign-in promo banner
export const SIGN_IN_PROMO_BANNER_BG = `linear-gradient(135deg, ${BRAND_50} 0%, ${BRAND_100} 100%)`
export const SIGN_IN_PROMO_BANNER_PILL_BG = BRAND_50
export const SIGN_IN_PROMO_BANNER_PILL_BORDER = BRAND_200
export const SIGN_IN_PROMO_BANNER_CTA_BG = BRAND_700
export const SIGN_IN_PROMO_BANNER_CTA_HOVER_BG = BRAND_800
